import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        // Clean hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user?.role === "admin" ? "/dashboard" : "/");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-[#86868b] text-[14px]">…</div>
    </main>
  );
}
